<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.title-signup{
  margin-top: 2%;
}

.photos{
  display: grid;
  grid-template-columns: 50% 50%;
  grid-auto-rows: 165px;
  align-items: center;
  justify-items: center;
}
.r1c1{
  grid-column: 1;
  grid-row: 1;
}
.r1c2{
  grid-column: 2;
  grid-row: 1;
}
.r2c1{
  grid-column: 1;
  grid-row: 2;
}
.r2c2{
  grid-column: 2;
  grid-row: 2;
}
.r3c1{
  grid-column: 1;
  grid-row: 3;
}
.r3c2{
  grid-column: 2;
  grid-row: 3;
}

.photo{
  width: 150px;
  height: 150px;
  border: 2px #777 solid;
  /* border-radius: 150px; */
  border-radius: 10px;
  margin: auto;
}

.plus{
  width: 150px;
  height: 150px;
  padding: 47px 0 0 3px;
  font-size: 41px;
  color: white;
  text-align: center;
}

.profile-pic{
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
}

.has-buttons{
  height: 120px;
}

</style>

<div class="bg">
  <div class="title-signup">Add photos</div>
  
  <div class="photos">
    <div class="r1c1">
      <div class="photo">
        {#if photos[0].p}
          <img src="{photos[0].p}" class="profile-pic" on:click="{ () => photoClicked(0) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(0) }">+</div>
        {/if}
      </div>
    </div>
    <div class="r1c2">
      <div class="photo">
        {#if photos[1].p}
          <img src="{photos[1].p}" class="profile-pic" on:click="{ () => photoClicked(1) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(1) }">+</div>
        {/if}
      </div>
    </div>
    
    <div class="r2c1">
      <div class="photo">
        {#if photos[2].p}
          <img src="{photos[2].p}" class="profile-pic" on:click="{ () => photoClicked(2) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(2) }">+</div>
        {/if}
      </div>
    </div>
    <div class="r2c2">
      <div class="photo">
        {#if photos[3].p}
          <img src="{photos[3].p}" class="profile-pic" on:click="{ () => photoClicked(3) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(3) }">+</div>
        {/if}
      </div>
    </div>
    
    <div class="r3c1">
      <div class="photo">
        {#if photos[4].p}
          <img src="{photos[4].p}" class="profile-pic" on:click="{ () => photoClicked(4) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(4) }">+</div>
        {/if}
      </div>
    </div>
    <div class="r3c2">
      <div class="photo">
        {#if photos[5].p}
          <img src="{photos[5].p}" class="profile-pic" on:click="{ () => photoClicked(5) }">
        {:else}
          <div class="plus" on:click="{ () => photoClicked(5) }">+</div>
        {/if}
      </div>
    </div>
  </div>
  <div class="has-buttons"></div>
  
</div>

<!-- <div class="next">
  <button on:click="{next}" disabled="{nextDisabled}">Next</button>
</div> -->
<NextButton on:click="{next}" disabled="{nextDisabled}"></NextButton>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import NextButton from "../../../../components/NextButton.svelte";

import Signup from "../../../../helpers/Signup.js";
import Validate from "../../../../helpers/Validate.js";

import { onMount } from "svelte";
onMount(async () => {
  try {
    Signup.verifyPersonalObject();
  } catch (e) {
    console.log("error:", e);
    
    if (e == "Must start from beginning") {
      document.location = "/";
    }
    
    return;
  }
  
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // Signup.deleteFromObject("photos", [1,0,0]);
  // Signup.addPersonalObject("photos", [], [1,0,0]);
  
  // Signup.deleteFromObject("photoIds", [1,1,1]);
  // Signup.addPersonalObject("photoIds", [], [1,1,1]);
  
  
  allowSignup = true;
  // Signup.saveToPersonalObject("photos", [ {c: "nop", i: "", p: ""}, {c: "nop", i: "", p: ""}, {c: "nop", i: "", p: ""}, {c: "nop", i: "", p: ""}, {c: "nop", i: "", p: ""}, {c: "nop", i: "", p: ""}, ]);
  photosSaved = Signup.getPersonalObject("photosSaved");
  
  photos = Signup.getPersonalObject("photos");
  if (photos.length == 0) {
    photos = [ 
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
      {c: "nop", i: "", p: ""},
    ];
  }
  // console.log("photos:", photos);
  
  // Signup.saveToPersonalObject("photoIds", [ "", "", "", "", "", "", ]);
  photoIds = Signup.getPersonalObject("photoIds");
  
  if (photoIds.length == 0) {
    photoIds = [ "", "", "", "", "", "", ];
  }

  if (photosSaved == true) {
    nextDisabled = false;
  } else {
    check();
  }
  
});

let allowSignup = false;
let nextDisabled = true;

let fileInput = "";
let photosSaved = false;
let photos = [ 
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
  {c: "nop", i: "", p: ""},
];

let photoIds = [ "", "", "", "", "", "", ];


function photoClicked(index) {
  push("/signup/profile/personal/photos-edit/" + index);
}


function check() {
  photosSaved = false;
  try {
    Validate.allowSignup(allowSignup);
    
    let imagesExist = false;
    for (let i in photos) {
      if (photos[i].p != "") {
        imagesExist = true;
        break;
      }
    }
    
    if (imagesExist == false) throw "Images don't exist.";
    
    nextDisabled = false;
  } catch (e) {
    nextDisabled = true;
    console.log("error:", e);
  }
}


async function next() {
  if (photosSaved == false) {
    await Signup.saveToPersonalObject("photosSaved", true);
    await Signup.saveProfilePhotos();
  }
  
  push("/signup/profile/personal/add-interests");
}


</script>